// i18n bootstrap. German is the primary locale; English is a full peer.
// Language is browser-detected, overridable, and persisted to localStorage
// (and later synced to the user profile via Account → Sprache).
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "../locales/de.json";
import en from "../locales/en.json";

export const SUPPORTED_LOCALES = ["de", "en"] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "easyhelp.locale",
      caches: ["localStorage"],
    },
  });

export default i18n;
